module.exports = __webpack_public_path__ + "static/img/0.a9ffb03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/0.jpg
// module id = LYZP
// module chunks = 3